import {catchError, map} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {CommunicationService} from '../service/communication.service';
import {Observable} from 'rxjs';
import {AdminUserModel} from '../model/Admin-user.model';
import {Page, PageQuery, SortQuery} from '../model/shared/Page.model';

@Injectable()
export class AdminApi extends CommunicationService {
  protected apiEndpoint = this.env.apiEndpoint + 'admins';

  findList(pageQuery: PageQuery, sortQuery: SortQuery, filter): Observable<Page<AdminUserModel>> {
    const params = {
      page: pageQuery.number.toString(),
      count: pageQuery.size.toString(),
      order: sortQuery.direction ? sortQuery.direction.toUpperCase() : null,
      sort: sortQuery.property ? sortQuery.property : null,
      search: filter,
    };
    const url = this.apiEndpoint + '/list';
    return this.requestService.get(url, {params}).pipe(
      map(response => response as Page<AdminUserModel>),
      catchError(this.handleError),
    );
  }

  createAdmin(admin: Partial<AdminUserModel>): Observable<AdminUserModel> {
    const url = this.apiEndpoint;
    return this.requestService.post(url, admin).pipe(
      map(response => response as AdminUserModel),
      catchError(this.handleError),
    );
  }

  updateAdmin(id: string | number, admin: Partial<AdminUserModel>): Observable<AdminUserModel> {
    const url = this.apiEndpoint + `/${id}`;
    return this.requestService.put(url, admin).pipe(
      map(response => response as AdminUserModel),
      catchError(this.handleError),
    );
  }

  deleteAdmin(id: string | number): Observable<void> {
    const url = this.apiEndpoint + `/${id}`;
    return this.requestService.remove(url).pipe(
      catchError(this.handleError),
    );
  }

  deactivateAdmin(id: string | number): Observable<AdminUserModel> {
    const url = this.apiEndpoint + `/${id}/deactivate`;
    return this.requestService.put(url, {}).pipe(
      map(response => response as AdminUserModel),
      catchError(this.handleError),
    );
  }
}
